import type { ThreadSummary } from "../../../../api/threads/threadDecoders";

/**
 * When a Thread about the document last moved, by the project's live list, or `null`: an
 * acceptance there may have changed what the document shows (review S3).
 */
export function documentActivity(threads: readonly Pick<ThreadSummary, "subject" | "lastEntryAt">[] | null, documentId: string): string | null {
  const about = `${documentId}@`;
  let newest: string | null = null;
  for (const thread of threads ?? []) {
    if (thread.subject?.startsWith(about) === true && (newest === null || thread.lastEntryAt > newest)) newest = thread.lastEntryAt;
  }
  return newest;
}
